import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadAIUXSprint'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'AI UX スプリント プロトタイプ プロトタイピング 資料 ホワイトペーパー'}
        image={'https://aitria.co.jp/images/img/download/ai-ux-sprint/ogp.png'}
        url={'https://aitria.co.jp/download/ai-ux-sprint/'}
        title="AI-UXスプリントサービス紹介資料 | 資料ダウンロード | Aitria（アイトリア）"
        description="AI×UX専門家が曖昧な要件を最短2週間でプロトタイプ化。議論を加速し、本質的な体験設計を可能にするアプローチをご紹介します。AIによる「実務で使えないUI」の罠を回避したいなら 、最短2週間で停滞を「議論できる体験」へ変える本手法をご活用ください。"
      />
      <Template />
    </>
  )
}

export default Download
